import { Map } from 'immutable';

import { getSize } from '../../../iterable/getSize';

import { WAIT_FOR_SYNC } from '../../../../constants/shops';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';
import ATTRIBUTE from '../../../../constants/attributes';

import actions from '../../../../actions';

export function files({ channel, operation, preview }) {
  const actionsToDispatch = [];
  const payload = [];

  for (let index = 0; index < getSize(preview.getIn([ATTRIBUTE.FILES, VALUE])); index += 1) {
    switch (operation) {
      case OPERATIONS[channel].FILES.ADD: {
        payload.push(Map({ type: operation, value: preview.getIn([ATTRIBUTE.FILES, VALUE, index]) }));

        if (!getSize(actionsToDispatch)) {
          actionsToDispatch.push(actions.bulkEdit.setData({ waitForSync: WAIT_FOR_SYNC.FINISH }));
        }

        break;
      }

      case OPERATIONS[channel].FILES.REPLACE: {
        const value = preview.getIn([ATTRIBUTE.FILES, VALUE, index]);

        if (!value) continue;

        payload.push(Map({ type: operation, value: Map({ targetIndex: index, replacement: value }) }));

        if (!getSize(actionsToDispatch)) {
          actionsToDispatch.push(actions.bulkEdit.setData({ waitForSync: WAIT_FOR_SYNC.FINISH }));
        }

        break;
      }

      case OPERATIONS[channel].FILES.DELETE: {
        if (!preview.getIn([ATTRIBUTE.FILES, VALUE, index])) continue;

        payload.unshift(Map({ type: operation, value: Map({ targetIndex: index }) }));
        break;
      }

      default:
        break;
    }
  }

  return { actions: actionsToDispatch, payload };
}
